import type { ZodError } from 'zod';

import { useStore } from '@tanstack/react-form';

import { getFieldErrorMessage } from './lib/helpers';

import { useFormContext } from './form';

export const useFieldErrors = (name: string) => {
  const form = useFormContext();

  const fieldErrors = useStore(
    form.store,
    (state) => state.errors[0]?.[name] as (ZodError | string)[],
  );

  const fieldMeta = useStore(
    form.store,
    (state) => (state.fieldMeta as Record<string, any>)?.[name],
  );

  if (!fieldMeta?.isTouched) return;

  const errors: Set<string> = new Set();
  if (fieldMeta?.errors.length) {
    fieldMeta.errors.forEach((error: any) => {
      errors.add(getFieldErrorMessage(error));
    });
  }

  /**
   * Remove this after issue is closed: https://github.com/TanStack/form/issues/1460
   */
  if (fieldErrors?.length) {
    fieldErrors.forEach((error) => {
      errors.add(getFieldErrorMessage(error));
    });
  }

  return errors.size > 0 ? Array.from(errors) : undefined;
};
